class HttpClient {
    /**
     * @param {Parameters<typeof fetch>} args
     * */
    async fetch(...args) {
        const response = await fetch(...args).catch((error) => {
            this.#fetchErrorSubscribers.forEach(cb => cb({ error, args }));
            throw new Error(error);
        });
        let body = null;
        if (response.headers.get('Content-Type').includes('application/json')) {
            body = await response.json().catch(() => null);
        }
        return {
            response,
            body,
        };
    }
    onFetchError(cb) {
        this.#fetchErrorSubscribers.push(cb);
    }
    #fetchErrorSubscribers = [];
}
export const httpClient = new HttpClient();
